<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('CustomerAct')"
      :active.sync="isSidebarActiveLocal"
      fullscreen
      @cancel="clearFields"
      @close="clearFields"
    >
      <CustomerActWithExcel
        :isSidebarActive="addNewActExcelSidebar"
        @closeSidebar="toggleActExcelSidebar"
        :data="sidebarAct"
      />
      <b-row>
        <b-col cols="4">
          <b-row class="justify-content-md-center mb-5">
            <b-col cols="12" md="auto" class="pr-0">
              <b-button
                class="bg-dark"
                style="border-color: white"
                v-on:click="toggleOperations(false)"
              >
                {{ $t("ManualOperation") }}</b-button
              >
            </b-col>
            <b-col cols="12" md="auto">
              <b-button
                class="bg-dark"
                style="border-color: white"
                v-on:click="toggleOperations(true)"
              >
                {{ $t("ExcelOperation") }}</b-button
              >
            </b-col>
          </b-row>
          <vs-card v-if="manualOperation">
            <b-row class="mb-8 mt-8">
              <UploadBtnDynamic :isUploaded="isUploaded" />
            </b-row>
            <b-row class="justify-content-md-end">
              <b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="clear()"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="12" md="auto" style="padding: 0px">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="downloadSample()"
                >
                  {{ $t("SampleExcel") }}</b-button
                >
              </b-col>
              <b-col cols="12" md="auto" >
                <b-button
                 class="bg-primary"
                  style="border-color: white"
                  v-on:click="addCustomerActExcel()"
                >
                  {{ $t("AddWholeExcel") }}
                </b-button></b-col
              >
            </b-row>
          </vs-card>
          <vs-card v-else>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  class="label-cs"
                  :label="'* ' + $t('CreateDate')"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-datepicker
                  id="baslangic"
                  v-model="createDate"
                  size="md"
                  :locale="locale"
                  class="mb-2"
                  today-variant="danger"
                  placeholder="-"
                  :start-weekday="weekday"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
                <span class="text-danger text-sm" v-show="errors.has('createDate')">{{
                  errors.first("createDate")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  class="label-cs"
                  :label="'* ' + $t('Payee')"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="payee"
                  type="text"
                  class="w-full"
                  name="payee"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('payee')">{{
                  errors.first("payee")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  class="label-cs"
                  :label="'* ' + $t('Dept')"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="dept"
                  type="text"
                  class="w-full"
                  name="dept"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('dept')">{{
                  errors.first("dept")
                }}</span>
              </b-col>
            </b-row>

            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  class="label-cs"
                  :label="'* ' + $t('peymentType')"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <v-select
                  color="danger"
                  v-model="peymentType"
                  :options="peyment_options"
                  size="small"
                  class="mb-2"
                  label="name"
                  autocomplete
                  ref="selectElement"
                  name="user_IsActive"
                >
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('peymentType')">{{
                  errors.first("peymentType")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  class="label-cs"
                  :label="$t('Description')"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-textarea v-model="description" />
              </b-col>
            </b-row>
            <b-row align-h="end">
              <b-col cols="3" md="auto" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="clear()"
                >
                  <Icon
                    icon="material-symbols:cancel-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Cancel") }}
                </b-button>
              </b-col>
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="saveCustomerAct()"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Save") }}
                </b-button>
              </b-col>
            </b-row>
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <ag-grid-vue
              style="width: 100%; height: 400px; margin-top: 25px"
              class="ag-theme-alpine"
              :suppressRowClickSelection="true"
              :defaultColDef="defaultColDef"
              :columnDefs="stockActColumns"
              :rowData="stockAct"
              :localeText="localeText"
              @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </vs-card>
        </b-col>
      </b-row>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import CustomerActWithExcel from "./CustomerActWithExcel.vue";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import moment from "moment";
import CustomerActUpdateDeleteBtn from "./CellRenderers/CustomerActUpdateDeleteBtn.vue";
import UploadBtnDynamic from "../components/global-components/UploadBtnDynamic.vue";
import userJson from "../../../public/user.json";
export default {
  components: {
    UploadBtnDynamic,
    AgGridVue,
    vSelect,
    CustomerActWithExcel,
    Icon,
    uuid,
    CustomerActUpdateDeleteBtn,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      isUploaded: false,
      manualOperation: false,
      localData: [],
      dept: 0,
      payee: 0,
      weekday: 1,

      locale: "de",
      createDate: "",
      sidebarAct: {},

      addNewActExcelSidebar: false,

      customer: "",
      peymentType: "",
      description: "",
      customer_choices: [],
      peyment_options: [],

      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      stockActColumns: [],
      stockAct: [],
      ROLE: this.$store.state.AppActiveUser.ROLE,
      CompnayTransId: "",
      OrderSource: "",
      OrderNumber: "",
      CompanyTransType: "",
      CompanyId: "",
      CompanyName: "",
      CompanyInfoId: "",
      CompanyInfoName: "",
    };
  },
  methods: {
    toggleOperations(val = false) {
      this.manualOperation = val;
    },
    downloadSample() {
      const link = document.createElement("a");
      link.href =  userJson.assetsUrl +"CustomerTransSampleTemplate.xlsx";
      link.download = "CustomerTransSampleTemplate.xlsx";
      link.click();
    },
    deleteActTrans(param) {
      this.$store
        .dispatch("customer/deleteCustomerAct", param.CompnayTransId)
        .then((response) => {
          if (response.data.success == true) {
            this.getCustomerAct();
            vs.notify({
              text: response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    editActTrans(param) {
      this.createDate = param.CreateDate;
      this.payee = param.Payee;
      this.dept = param.Dept;
      this.peymentType = param.PeymentType;
      this.description = param.Description;

      this.CompnayTransId = param.CompnayTransId;
      this.OrderSource = param.OrderSource;
      this.OrderNumber = param.OrderNumber;
      this.CompanyTransType = param.CompanyTransType;
      this.CompanyId = param.CompanyId;
      this.CompanyName = param.CompanyName;
      this.CompanyInfoId = param.CompanyInfoId;
      this.CompanyInfoName = param.CompanyInfoName;
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    clear() {
      this.dept = 0;
      this.payee = 0;
      this.peymentType = "";
      this.description = "";
      this.createDate = "";
      this.wholeStockList = [];
      this.isUploaded = false;
    },
    clearFields() {
      this.dept = 0;
      this.payee = 0;
      this.peymentType = "";
      this.description = "";
      this.createDate = "";
      this.stockActColumns = [];
      this.stockAct = [];
      this.wholeStockList = [];

      this.CompnayTransId = "";
      this.OrderSource = "";
      this.OrderNumber = "";
      this.CompanyTransType = "";
      this.CompanyId = "";
      this.CompanyName = "";
      this.CompanyInfoId = "";
      this.CompanyInfoName = "";
      this.isUploaded = false;
      document.getElementById("xmlListForExcel").value = "";
    },
    getCustomerAct() {
      const vs = this.$vs;
      if (this.localData.length == 0) this.localData = this.data;
      this.stockAct = [];
      this.stockActColumns = [];
      this.$store
        .dispatch("customer/listCustomerActForCompany", this.localData.CompanyId)
        .then((response) => {
          if (response.success == true) {
            this.stockAct = JSON.parse(response.json);
            if (this.stockAct.length > 0) {
              let columnList = Object.keys(this.stockAct[0]);
              this.stockActColumns.push({
                width: 100,
                pinned: "left",
                cellRendererFramework: "CustomerActUpdateDeleteBtn",
                cellRendererParams: {
                  addMethods: "addBarcodePopup",
                  addIcon: "ph:barcode",
                },
              });
              columnList.forEach((val, index) => {
                if (val.toString().includes("Date") == true) {
                  this.stockActColumns.push({
                    cellRendererFramework: "TextViewCellRenderer",
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                    valueFormatter: (params) => this.parseDate(params.data[val]),
                  });
                } else if (val.toString().includes("Id") == true) {
                } else
                  this.stockActColumns.push({
                    cellRendererFramework: "TextViewCellRenderer",
                    headerName: this.$t(val),
                    field: val,
                    filter: "agSetColumnFilter",
                  });
              });
            }
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
    },
    saveCustomerAct() {
      const vs = this.$vs;
      let args = [];
      if (this.localData.length == 0) this.localData = this.data;
      var createdId = uuid.v4();
      if (this.payee == 0 && this.dept == 0) {
        vs.notify({
          text: this.$t("actWarning"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        if (this.CompnayTransId == "") {
          args = {
            compnayTransId: createdId,
            orderSource: "",
            orderNumber: "",
            payee: this.payee,
            dept: this.dept,
            description: this.description,
            peymentType: this.peymentType,
            companyTransType: this.payee == 0 || this.payee == "" ? "B" : "A",
            createDate: this.createDate,
            companyId: this.localData.CompanyId,
            companyName: this.localData.CompanyName,
            companyInfoId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            companyInfoName: "",
          };
          this.$store
            .dispatch("customer/addCustomerAct", args)
            .then((response) => {
              if (response.status == 200) {
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.getCustomerAct();
              } else {
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          args = {
            compnayTransId: this.CompnayTransId,
            orderSource: this.OrderSource,
            orderNumber: this.OrderNumber,
            payee: this.payee,
            dept: this.dept,
            description: this.description,
            peymentType: this.peymentType,
            companyTransType: this.payee == 0 || this.payee == "" ? "B" : "A",
            createDate: this.createDate,
            companyId: this.localData.CompanyId,
            companyName: this.localData.CompanyName,
            companyInfoId: this.CompanyInfoId,
            companyInfoName: this.CompanyInfoName,
          };
          this.$store
            .dispatch("customer/updateCustomerAct", args)
            .then((response) => {
              if (response.status == 200) {
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.getCustomerAct();
              } else {
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        }
      }
    },
    getPaymentOptions() {
      this.paymnetListOption = [];
      this.peyment_options = [];
      this.paymnetListOption = this.payment;

      this.peyment_options = Object.values(this.paymnetListOption);
    },

    setItems(items) {
      this.columnDefsForExcel = [];
      let list = this.wholeStockList[0];
      this.stockAct = this.wholeStockList;
      let columnList = Object.keys(list);
      columnList.forEach((val, index) => {
        if (val == "createDate") {
          this.stockActColumns.push({
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
            valueFormatter: (params) => this.parseDate(params.data[val]),
          });
        } else if (val !== "Resim") {
          this.stockActColumns.push({
            field: val,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
          });
        }
      });
    },
    addCustomerActExcel() {
      this.saveCustomerActExcel(this.wholeStockList.length - 1);
    },
    saveCustomerActExcel(index) {
      const vs = this.$vs;
      let args = [];
      if (this.localData.length == 0) this.localData = this.data;
      var createdId = uuid.v4();
      if (index == -1) {
        vs.notify({
          text: this.$t("actWarning"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
        this.getCustomerAct();
      } else {
        let deptLocal = this.wholeStockList[index].hasOwnProperty("dept")
          ? this.wholeStockList[index].dept
          : "";
        let payeeLocal = this.wholeStockList[index].hasOwnProperty("payee")
          ? this.wholeStockList[index].payee
          : "";

        if (deptLocal == "" && payeeLocal == "") {
          vs.notify({
            text: this.$t("actWarning"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          index--;
          this.saveCustomerActExcel(index);
        } else {
          args = {
            compnayTransId: createdId,
            orderSource: "",
            orderNumber: "",
            payee: payeeLocal,
            dept: deptLocal,
            description: this.wholeStockList[index].hasOwnProperty("description")
              ? this.wholeStockList[index].description
              : "",
            peymentType: this.wholeStockList[index].paymentType,
            companyTransType:
              this.wholeStockList[index].payee == 0 ||
              this.wholeStockList[index].payee == ""
                ? "B"
                : "A",
            createDate: this.wholeStockList[index].createDate,
            companyId: this.localData.CompanyId,
            companyName: this.localData.CompanyName,
            companyInfoId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            companyInfoName: "",
          };
          this.$store
            .dispatch("customer/addCustomerAct", args)
            .then((response) => {
              if (response.status == 200) {
                index--;
                this.saveCustomerActExcel(index);
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              } else {
                index--;
                this.saveCustomerActExcel(index);
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        }
      }
    },
    toggleActExcelSidebar(val = false) {
      this.addNewActExcelSidebar = val;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },
  watch: {
    wholeStockList(val) {
      return val;
    },
    payment(val) {
      this.getPaymentOptions();
      return val;
    },
    data(val) {
      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        this.localData = this.data;
        this.getCustomerAct();
      }
      return val;
    },
  },

  created() {
    this.locale = this.$i18n.locale == "en" ? "en-US" : this.$i18n.locale;
    this.getPaymentOptions();
  },
  computed: {
    payment: {
      get() {
        return this.$store.state.customer.Payment;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("editDataBtnAct", (paramDetail) => {
      this.editActTrans(paramDetail);
    });
    this.$root.$on("deleteDataBtnAct", (paramDetail) => {
      this.deleteActTrans(paramDetail);
    });
    this.$root.$on("excelData", (paramDetail) => {
      if (paramDetail) this.isUploaded = true;
      this.wholeStockList = paramDetail;
    });
  },
  beforeDestroy() {
    this.$root.$off("editDataBtnAct");
    this.$root.$off("excelData");
  },
};
</script>
